export default __webpack_public_path__ + "static/O0296-840f81af0ab79c6ff7a69a0bce9ff5e7.png";